import React from 'react';
import FlatTireIcon from 'assets/icons/flatTire.svg?react';
import RefreshIcon from 'assets/icons/refresh.svg?react';

import styles from './WidgetErrorMessage.module.css';
import Button from 'components/Button/Button';

type WidgetErrorMessageProps = {
    message: string;
    title?: string;
    onRetry?: () => void;
};

function WidgetErrorMessage({
    message,
    title = 'Oops, we hit a bump in the road',
    onRetry,
}: WidgetErrorMessageProps): JSX.Element {
    return (
        <div className={styles.widgetErrorMessage}>
            <div className={styles.flatTireIcon}>
                <FlatTireIcon />
            </div>
            <h4>{title}</h4>
            <p>{message}</p>
            {onRetry && (
                <Button onClick={onRetry} color="info" className={styles.retryButton} size="sm">
                    <RefreshIcon /> Retry
                </Button>
            )}
        </div>
    );
}

export default WidgetErrorMessage;
